import { atom } from 'recoil';

export const isNewWithDrawModalOpenAtom = atom<boolean>({
  key: 'isNewWithDrawOpen',
  default: false,
});
